module.exports = __webpack_public_path__ + "img/facebook--white.f762c042.svg";